import './Tabs.css';
import React, {useState} from "react";
import noodlepediaHeader from '../../assets/images/noodlepediaHeader.png';
import woodPlank from '../../assets/images/woodPlank.png';
import ActiveNoodle from '../../components/ActiveNoodle.js';
import NoodleList from '../../components/NoodleList.js';
import ViewSettings from '../../components/ViewSettings.js';

function Noodlepedia(props)  {
    const [activeNoodle, setActiveNoodle] = useState(null);
    const [expandedViewSettings, setExpandedViewSettings] = useState(false);
    const [selectedSort, setSelectedSort] = useState("default");

    return (
        <div >
        { activeNoodle !== null && 
          <ActiveNoodle setUserProfile={props.setUserProfile} userProfile={props.userProfile} noodle={activeNoodle} setActiveNoodle={setActiveNoodle}/>
        }
        <img className="backgroundImage" src={woodPlank} alt="wooden slat planks acting as a backdrop for the noodle display" />
        <div >
        <img className="noodlepediaHeader" src={noodlepediaHeader} alt="black noodles wiggling across the page with NOODLEPEDIA written on top" />
        </div>
        <NoodleList selectedSort={selectedSort} userProfile={props.userProfile} setActiveNoodle={setActiveNoodle}/>
        <ViewSettings selectedSort={selectedSort} setSelectedSort={setSelectedSort} expandedViewSettings={expandedViewSettings} setExpandedViewSettings={setExpandedViewSettings} />
      </div>
    )
}

export default Noodlepedia;